import { connect } from 'react-redux';
import { Breadcrumb, Dropdown, Form, Icon, Label, Menu, Radio, Segment, Tab } from 'semantic-ui-react';
import PageContainer from '../common/PageContainer';
import * as actions from '../../redux/actions';
import * as selectors from '../../redux/selectors';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { TextField } from '../common/FormFields';
import { Formik } from 'formik';
import { userGroupValidationSchema } from './admin.constants';
import AddUserDialogFromMenuItem from './AddUserDialogFromMenuItem';
import AddFirmDialogFromMenuItem from './AddFirmDialogFromMenuItem';
import EditOrganizationUsers from './EditOrganizationUsers';
import EditOrganizationFirms from './EditOrganizationFirms';

export const EditOrganization = ({ match, users, organization, setGroup, updateGroup }) => {
  const id = match.params.id;

  useEffect(() => {
    setGroup(id);
  }, [id]);

  const handleSubmit = org => updateGroup(org);

  const panes = [
    {
      menuItem: (
        <Menu.Item key="users">
          Users
          <Label>{organization && organization.id && organization.users.length}</Label>
        </Menu.Item>
      ),
      render: () => (
        <Tab.Pane>
          <EditOrganizationUsers organization={organization} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: (
        <Menu.Item key="firms">
          Showcase Firms
          <Label>{organization && organization.id && organization.showcaseFirms.length}</Label>
        </Menu.Item>
      ),
      render: () => (
        <Tab.Pane>
          <EditOrganizationFirms organization={organization} />
        </Tab.Pane>
      ),
    },
  ];

  const getPage = () => (
    <Formik
      initialValues={organization}
      enableReinitialize
      validationSchema={userGroupValidationSchema}
      onSubmit={handleSubmit}
    >
      {formik => (
        <>
          <Breadcrumb>
            <Breadcrumb.Section>Admin</Breadcrumb.Section>
            <Breadcrumb.Divider icon="right angle" />
            <Breadcrumb.Section>
              <Link to="/admin/organization">Organizations</Link>
            </Breadcrumb.Section>
            <Breadcrumb.Divider icon="right angle" />
            <Breadcrumb.Section>Edit Organization</Breadcrumb.Section>
          </Breadcrumb>

          <Menu borderless attached="top">
            <Menu.Item header>
              <Icon name="building outline" />
              {organization.name}
            </Menu.Item>

            <Menu.Menu position="right">
              <Menu.Item>
                <Dropdown text="Actions" icon="chevron down" floating labeled button className="icon">
                  <Dropdown.Menu>
                    <Dropdown.Item
                      icon="save"
                      disabled={!formik.isValid || formik.isSubmitting}
                      text="Save changes"
                      onClick={() => formik.handleSubmit(formik)}
                    />
                    <AddUserDialogFromMenuItem />
                    <AddFirmDialogFromMenuItem />
                  </Dropdown.Menu>
                </Dropdown>
              </Menu.Item>
            </Menu.Menu>
          </Menu>

          <Segment attached>
            <Form onSubmit={formik.handleSubmit}>
              <TextField
                name="name"
                label="Name"
                formik={formik}
                value={formik.values.name}
                onChange={formik.handleChange}
                error={formik.touched.name && Boolean(formik.errors.name)}
                errorMessage={formik.errors.name}
              />

              <Form.Field>
                <label>Is Owner</label>
                <Radio
                  toggle
                  checked={formik.values.isOwner}
                  onChange={(e, d) => formik.setFieldValue('isOwner', d.checked)}
                />
              </Form.Field>
            </Form>
          </Segment>

          <br />
          {organization && organization.id && <Tab panes={panes} />}
        </>
      )}
    </Formik>
  );

  return <PageContainer>{organization && organization.id && getPage()}</PageContainer>;
};

const mapStateToProps = state => ({
  users: selectors.getUsers(state),
  organization: selectors.getCurrentGroup(state),
});

const mapDispatchToProps = dispatch => ({
  setGroup: bindActionCreators(actions.admin.setGroup, dispatch),
  updateGroup: bindActionCreators(actions.admin.updateUserGroup, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditOrganization);
